import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signupdone',
  templateUrl: './signupdone.component.html',
  styleUrls: ['./signupdone.component.scss']
})
export class SignupDoneComponent implements OnInit{
  userEmail: string = '';

  constructor(private readonly router: Router) {
   
  }
  ngOnInit(){
     this.userEmail =localStorage.getItem('signedinEmail');
  }

  goToDashboard() {
    localStorage.removeItem(`signup-${localStorage.getItem('signedinEmail')}`);
    this.router.navigate(['/']);
  }

  closeModal() {
    this.router.navigate(['/']);
  }
}
